import {
  AncillaryManagerListQuery,
  Int32IdAndLabel,
} from "../../../integrated-client/models";
import {
  DEFAULT_LIMIT_PAGINATION,
  DEFAULT_OFFSET,
  DEFAULT_TOTAL_ITEMS,
} from "../../../utils/Constants";

export interface IAncillaryManagerFiltersData
  extends AncillaryManagerListQuery {}

export class AncillariesManagerFiltersData
  implements IAncillaryManagerFiltersData
{
  ancillaryType?: Int32IdAndLabel;
  ancillaryName?: string | null;
  offset: number;
  limit: number;
  currentPage: number;
  total: number;

  constructor() {
    this.offset = DEFAULT_OFFSET;
    this.limit = DEFAULT_LIMIT_PAGINATION;
    this.total = DEFAULT_TOTAL_ITEMS;
    this.currentPage = 1;
  }
}
